export var mainBannerImg = {
    backgroundImage: `url(/images/hire-experts/engagment-model-bg.avif)`,
};

export const bannerList = [
    { list: "Freelance contractors" },
    { list: "Full-time roles" },
    { list: "Global teams" },
];